
export default {
  login: 'LOGIN INTO THE PLATFORM',
  problems_to_login: 'Problems to login into the system?',
  recover_password: 'Recover password',
  go_back: 'Go back',
  email_not_found: 'Email address {email} not found.',
  unexpected_error: 'Ocurrió un error inesperado. Si el problema persiste contacte al administrador.',
  password_successfully_restablish: 'Successfully restablished password',
  password_sent_to_email: 'Your new password has been sent to your email address.',
  // tslint:disable-next-line:max-line-length
  password_notification_sent: 'A notification has been sent to the admin proceed with the password restablishment.',
  accept: 'Accept',
  password_not_updated: 'Sorry, your password couldn\'t be updated.',
  password_confirm: 'Confirm password',
  password_confirmation: 'Password confirmation',
  new_password: 'New password',
  new_password_confirm: 'Confirm new password',
  save_new_password: 'Save new password',
  password_update: 'Password update',
  password_updated: 'Su nueva contraseña ha sido actualizada correctamente.',
  password_reset_requested: 'Password reset requested',
  check_your_email: 'We\'ve sent an email to the specified address with the steps to take.',
  create_password: 'Create password',
  save_password: 'Save password',
  password_create: 'Password creation',
  password_created: 'Created password',
  password_not_created: 'Sorry, your password could not be created.',
  password_created_greet_title: 'Your password was created successfully',
  // tslint:disable-next-line:max-line-length
  password_created_greet_text: 'You can now use your e-mail adress as well as your password to login into the system',
  token_not_valid: 'The verification code is invalid',
  // tslint:disable-next-line:max-line-length
  token_expired: 'This code has expired, remember for your security our access codes only have a maximum of three days of validity',
  token_used: 'This code has already been used',
  // tslint:disable-next-line:max-line-length
  verify_or_contact: 'Verify the code or link you have used and try again. You can also contact OCC Solutions for more information',
  go_sign_in: 'Return to login.',
  logged_as_enterprise: 'Temporal session as enterprise',
  logged_as_employee: 'Temporal session as employee',
  logged_as_customer: 'Temporal session as customer',
  close_session: 'Close session',
  sign_up: 'Sign Up',
  select_customer_title: 'Select the account that best suits your needs',
  select_customer_personal: 'Personal account',
  select_customer_personal_text: 'You can register as an administrator and register your company to manage it personally',
  select_customer_personal_select: 'Select',
  select_customer_commercial: 'Commercial account',
  select_customer_commercial_text: 'You can register as an administrator to manage and manage multiple companies',
  select_customer_commercial_select: 'Select',
  has_no_account: 'Do not has account?',
  customer_personal_d: 'You can register yourself as admin and also can register your enterprise to handle it personally.',
  customer_commercial_d: 'You can register yourself as admin and can handle mutiple enterprises.',
  // tslint:disable-next-line:max-line-length
  customer_personal_d_2: 'Register an user as admin with him enterprise to handle it personally.',
  customer_commercial_d_2: 'Register an user as admin of many enterprises.',
  personal_account: 'Personal account',
  commercial_account: 'Commercial account',
  confirm_logout: 'Are you sure you want to log out?'
}
